// eslint-disable-next-line no-shadow
export enum BaseTypographyVariant {
	D1Light = 'd1_light',
	D1Regular = 'd1_regular',
	D1Bold = 'd1_bold',

	D1V2Light = 'd1_v2_light',
	D1V2Regular = 'd1_v2_regular',
	D1V2Bold = 'd1_v2_bold',

	D2Light = 'd2_light',
	D2Regular = 'd2_regular',
	D2Bold = 'd2_bold',

	D2V2Light = 'd2_v2_light',
	D2V2Regular = 'd2_v2_regular',
	D2V2Bold = 'd2_v2_bold',

	D3Light = 'd3_light',
	D3Regular = 'd3_regular',
	D3Bold = 'd3_bold',

	D3V2Light = 'd3_v2_light',
	D3V2Regular = 'd3_v2_regular',
	D3V2Bold = 'd3_v2_bold',

	H1Regular = 'h1_regular',
	H1Medium = 'h1_medium',
	H1Bold = 'h1_bold',

	H1V2Regular = 'h1_v2_regular',
	H1V2Medium = 'h1_v2_medium',
	H1V2Bold = 'h1_v2_bold',

	H2Regular = 'h2_regular',
	H2Medium = 'h2_medium',
	H2Bold = 'h2_bold',

	H2V2Regular = 'h2_v2_regular',
	H2V2Medium = 'h2_v2_medium',
	H2V2Bold = 'h2_v2_bold',

	T1Regular = 't1_regular',
	T1Medium = 't1_medium',
	T1Bold = 't1_bold',

	T1V2Regular = 't1_v2_regular',
	T1V2Medium = 't1_v2_medium',
	T1V2Bold = 't1_v2_bold',

	Body1 = 'body1',
	T2Regular = 't2_regular',
	T2Medium = 't2_medium',
	T2Bold = 't2_bold',

	T2V2Regular = 't2_v2_regular',
	T2V2Medium = 't2_v2_medium',
	T2V2Bold = 't2_v2_bold',

	B1Regular = 'b1_regular',
	B1Medium = 'b1_medium',
	B1Bold = 'b1_bold',

	B1V2Regular = 'b1_v2_regular',
	B1V2Medium = 'b1_v2_medium',
	B1V2Bold = 'b1_v2_bold',

	B2Regular = 'b2_regular',
	B2Medium = 'b2_medium',
	B2Bold = 'b2_bold',

	B2V2Regular = 'b2_v2_regular',
	B2V2Medium = 'b2_v2_medium',
	B2V2Bold = 'b2_v2_bold',

	B3Regular = 'b3_regular',
	B3Medium = 'b3_medium',
	B3Bold = 'b3_bold',

	B3V2Regular = 'b3_v2_regular',
	B3V2Medium = 'b3_v2_medium',
	B3V2Bold = 'b3_v2_bold',

	B2Caption = 'b2_caption',
	B2CaptionMedium = 'b2_caption_medium',
	B2CaptionBold = 'b2_caption_bold',

	Numbers = 'numbers',

	TooltipRegular = 'tooltip_regular',
	TooltipMedium = 'tooltip_medium',
	TooltipBold = 'tooltip_bold',

	TooltipV2Regular = 'tooltip_v2_regular',
	TooltipV2Medium = 'tooltip_v2_medium',
	TooltipV2Bold = 'tooltip_v2_bold',

	ND1 = 'nd1',
	ND2 = 'nd2',
	ND3 = 'nd3',
	NP1 = 'np1',
	NP2 = 'np2',
	NP3 = 'np3',
	NS1 = 'ns1',
	NS2 = 'ns2',
	NL1 = 'nl1',
	NL2 = 'nl2',
	NT = 'nt',

	InputLabel = 'input_label',
	InfoText = 'info_text',
	AlertHeader = 'alert_header',
}
